<template>
	<div id="small-navbar">
		<div class="container">
			<div
				class="row navbar-row d-flex align-items-center justify-content-between"
			>
				<div class="col-6">
					<div class="navbar-logo">
						<router-link :to="{ name: 'HomeScreen' }"
							><img class="navbar-logo" src="/images/logos/bb-logo-text.svg"
						/></router-link>
					</div>
				</div>
				<div class="col-6 d-flex justify-content-end align-items-center">
					<base-button
						class="buy-ebso"
						type="light-green"
						:text="$t('globals.navigation.buyEbso')"
						@clicked="handleBuyEbso"
					/>
					<div class="toggle-menu" @click="toggleMenu">
						<img src="/images/icons/burger_icon.svg" class="icon"/>
					</div>
				</div>
			</div>
		</div>
		<!-- <fee-row /> -->
		<ebso-info-row v-if="$route.path.includes('/products/ebso')" />
		<holoverz-info-row v-if="$route.path.includes('/products/holoverz')" />

		<transition name="slide-fade-bot">
			<mobile-navbar-menu
				v-if="mobileMenuIsOpen"
				:languageOptions="languageOptions"
				:navigations="navigations"
				:defaultLanguage="defaultLanguage"
				@closeMenu="closeMenu"
			/>
		</transition>
	</div>
</template>

<script>
import MobileNavbarMenu from './MobileNavbarMenu';
//import FeeRow from "@/components/modules/navbars/FeeRow.vue";
import EbsoInfoRow from "@/components/modules/navbars/EbsoInfoRow.vue";
import HoloverzInfoRow from "@/components/modules/navbars/HoloverzInfoRow.vue";

export default {
	name: 'SmallNavbar',
	props: {
		defaultLanguage: {
			type: Object,
			required: false,
		},
		languageOptions: {
			type: Array,
			required: false,
		},
		navigations: {
			type: Array,
			required: true,
		},
	},
	components: {
		MobileNavbarMenu,
		//FeeRow,
		EbsoInfoRow,
		HoloverzInfoRow,
	},
	data: () => ({
		mobileMenuIsOpen: false,
	}),
	created() {},
	computed: {},
	methods: {
		handleBuyEbso() {
			window.open('https://www.lbank.com/trade/ebso_usdt', '_blank');
		},
		closeMenu() {
			this.mobileMenuIsOpen = false;
		},
		toggleMenu() {
			this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
		},
	},
};
</script>

<style lang="scss" scoped>
#small-navbar {
	background: #e8e8ff;
	$navbarHeight: 45px;
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
	.container {
		@media (max-width: $breakpoint-sm) {
			max-width: 100%;
		}
	}
	.navbar-row {
		min-height: $navbarHeight;
		.navbar-logo {
			max-height: 20px;
		}

		.navigation {
			display: flex;
			align-items: center;
			list-style-type: none;
			margin: 0;
			padding: 0;
			position: relative;
			height: $navbarHeight;
		}
		.buy-ebso {
			margin-right: 14px;
			white-space: nowrap;
			padding: 6px 12px;
			font-size: $text-s;

			@media (max-width: $breakpoint-xxs) {
				margin-right: 10px;
				padding: 6px 8px;
			}
		}

		.toggle-menu {
			height: 45px;
			display: flex;
			align-items: center;
			img {
				cursor: pointer;
			}
		}
	}
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
